import { APIResponse, OrganisationMemberAPIPathGenerator, OrganisationMemberDocument } from "server-model";
import { OrganisationConnector, OrganisationMemberConnector } from "../data-connectors";
import { AppServerConnector } from "./app-server.connector";

export class AppServerOrganisationMemberConnector extends AppServerConnector implements OrganisationMemberConnector {
    async getOrganisationMember(organisationId: string, organisationMemberId: string): Promise<APIResponse> {
        try {
            const response = await this.axios.get(
                OrganisationMemberAPIPathGenerator.details(organisationMemberId),
                this.getHeaders()
            )
            if (response && response.status === 200) {
                return response.data
            } else {
                throw new Error("Organisation not found")
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    }
    async createOrganisationMember(organisationMemberDocument: OrganisationMemberDocument): Promise<APIResponse> {
        try {
            const response = await this.axios.post(
                OrganisationMemberAPIPathGenerator.create(),
                { organisationMemberDocument: this.toPlain(organisationMemberDocument) },
                this.getHeaders()
            )
            if (response && response.status === 200) {
                return response.data
            } else {
                throw new Error("Unable to create organisation")
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    }
    async updateOrganisationMember(organisationId: string, organisationMemberId: string, organisationMemberDocument: OrganisationMemberDocument): Promise<APIResponse> {
        try {
            const response = await this.axios.put(
                OrganisationMemberAPIPathGenerator.update(organisationMemberId),
                { organisationMemberDocument: this.toPlain(organisationMemberDocument) },
                this.getHeaders()
            )
            if (response && response.status === 200) {
                return response.data
            } else {
                throw new Error("Unable to update organisation")
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    }
    async deleteOrganisationMember(organisationId: string, organisationMemberId: string): Promise<APIResponse> {
        try {
            const response = await this.axios.delete(
                OrganisationMemberAPIPathGenerator.delete(organisationMemberId),
                this.getHeaders()
            )
            if (response && response.status === 200) {
                return response.data
            } else {
                throw new Error("Unable to delete organisation")
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    }
}